import React, { useEffect, createElement } from 'react';
interface SEOProps {
  title: string;
  description: string;
  image: string;
  url?: string;
}
export function SEO({
  title,
  description,
  image,
  url
}: SEOProps) {
  useEffect(() => {
    // Update title
    document.title = title;
    // Helper to update or create meta tags
    const updateMeta = (name: string, content: string, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // Basic Meta Tags
    updateMeta('description', description);
    // Open Graph / Facebook / WhatsApp
    updateMeta('og:type', 'website', 'property');
    updateMeta('og:url', url || window.location.href, 'property');
    updateMeta('og:title', title, 'property');
    updateMeta('og:description', description, 'property');
    updateMeta('og:image', image, 'property');
    updateMeta('og:image:width', '1200', 'property');
    updateMeta('og:image:height', '630', 'property');
    // Twitter
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:url', url || window.location.href, 'property');
    updateMeta('twitter:title', title, 'property');
    updateMeta('twitter:description', description, 'property');
    updateMeta('twitter:image', image, 'property');
    // Update favicon if needed
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = image;
  }, [title, description, image, url]);
  return null;
}